export const labelAlignment = (position) => {
    switch (position) {
        case 'right':
            return "row-reverse"
        case 'left':
            return "row"
        case 'center':
            return "column"
        default:
            return "column"
    }
}

export const labelAlignmentButtonDisplay = (position) => {
    switch (position) {
        case 'right':
            return { flexDirection: 'row-reverse' }
        case 'left':
            return { flexDirection: 'row' }
        case 'center':
            return { justifyContent: 'center' }
        default:
            return { justifyContent: 'center' }
    }
}